<div mat-dialog-title class="close" align="end">
    <button mat-icon-button aria-label="close dialog" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <iframe width="560" height="315" [src]="url | safe"></iframe>
</mat-dialog-content>
